import React, { useEffect, useState } from "react";
import logo from '../../assets/images/logo.png'
const Header = () => {
 
  return (
    <>
    <div className="d-flex justify-content-between">
                    <img src={logo} alt="logo" width="150" height="61" className="ms-56 mt-27 mb-5 " />
                    <div className="mt-40">
                        <h6 className="fw-bolder  text-dark"><i className="text-dark">Productivity Performance and Efficiency</i></h6>
                        <p className="fw-normal me-21 text-dark">Enterprise scale solutions ready to deploy your data</p>
                    </div>
                </div>
   
    </>
  );
};
export default Header;